<form [formGroup]="settingsForm()" (ngSubmit)="submit()">
  <div class="col-md-2 pl-0 mb-0">
    <input id="key" class="admin-settings" formControlName="key" [ngClass]="delChosen() ? 'setting-delete' : ''">
  </div>

  <div class="col-md-3 pl-0 mb-0">
    <input id="value" class="admin-settings" formControlName="value" [ngClass]="delChosen() ? 'setting-delete' : ''">
  </div>

  <div class="col-md-3 pl-0 mb-0">
    <p class="admin-settings">{{ setting?.description }}</p>
  </div>
  <div class="col-md-2 pl-0 mb-0">
    <p class="admin-settings">
      {{ setting?.mutDate | date: 'dd.MM.yyyy HH:mm' }}<br/>
      {{ setting?.mutUserName }}</p>
  </div>

  <div class="col-md-2 pl-0 mb-0">
    <button class="btn btn-sm admin-settings" type="submit"
            [ngStyle]="{ 'visibility': settingsForm().dirty ? '' : 'hidden'}"
            [disabled]="settingsForm().invalid">
      <i class="fa fa-check"></i>
    </button>

    <button class="btn btn-sm admin-settings" type="button" [title]="'global.cancel' | translate"
            [ngStyle]="{ 'visibility': settingsForm().dirty ? '' : 'hidden'}"
            (click)="reset()">
      <i class="fa fa-times"></i>
    </button>

    <button class="btn btn-sm admin-settings" type="button" [title]="'global.delete' | translate"
            (click)="confirmDelete()">
      <i class="fa fa-trash-o"></i>
    </button>
  </div>
</form>
